import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Heading, Text } from '@auspost/postmaster-react';

import ErrorIcon from 'assets/something-went-wrong.svg';

import styles from './ServiceUnavailable.module.scss';

const ServiceUnavailable: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(0);
  };

  return (
    <div className={styles.container} data-testid='service-unavailable'>
      <div className={styles.imageWrapper}>
        <ErrorIcon />
      </div>
      <Heading level='h3' isBold data-testid='header' className={styles.header}>
        Looks like something went wrong
      </Heading>

      <Text variant='body' className={styles.text} data-testid='body-text'>
        This isn&#39;t working right now, please try again later.
      </Text>
      <Button
        data-testid='button'
        className={styles.button}
        variant='primary'
        onClick={() => handleClick()}
        size='small'
      >
        Try again
      </Button>
    </div>
  );
};

export default ServiceUnavailable;
